<ng-container *transloco="let t; read: 'admin.tenants.dialog'">
  <app-modal [(open)]="open" [title]="t('editTitle')" size="medium" (closed)="onClose()">
    @if (isLoading()) {
      <p class="text-[13px] text-ink-2">{{ t('loading') }}</p>
    } @else {
      <form (ngSubmit)="onSubmit()" class="space-y-4">
        <app-form-field [label]="t('name')">
          <app-text-input [placeholder]="t('namePlaceholder')" [(ngModel)]="name" name="name" required></app-text-input>
        </app-form-field>

        <app-form-field [label]="t('alias')" [help]="t('aliasHelp')">
          <app-text-input [placeholder]="t('aliasPlaceholder')" [(ngModel)]="alias" name="alias" required></app-text-input>
        </app-form-field>

        <app-form-field [label]="t('description')">
          <app-text-input [placeholder]="t('descriptionPlaceholder')" [(ngModel)]="description" name="description"></app-text-input>
        </app-form-field>

        <app-form-field [label]="t('domains')" [help]="t('domainsHelp')">
          <app-text-input [placeholder]="t('domainsPlaceholder')" [(ngModel)]="domains" name="domains"></app-text-input>
        </app-form-field>

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <app-form-field [label]="t('contact')">
            <app-text-input [placeholder]="t('contactPlaceholder')" [(ngModel)]="contact" name="contact"></app-text-input>
          </app-form-field>
          <app-form-field [label]="t('region')">
            <app-text-input [placeholder]="t('regionPlaceholder')" [(ngModel)]="region" name="region"></app-text-input>
          </app-form-field>
        </div>

        <label class="flex items-center gap-2 text-[13px] font-semibold text-ink-2">
          <app-toggle [(ngModel)]="enabled" name="enabled"></app-toggle>
          {{ t('enabled') }}
        </label>
      </form>
    }

    <ng-template modalFooter>
      <div class="flex flex-1 items-center justify-end gap-2">
        <button type="button" (click)="onClose()"
          class="rounded-control border border-hairline bg-card px-4 py-2 text-[13px] font-semibold text-ink-1 hover:bg-sunken">
          {{ t('cancel') }}
        </button>
        <button type="button" (click)="onSubmit()" [disabled]="!isValid || isLoading() || isSaving()"
          class="rounded-control bg-action px-4 py-2 text-[13px] font-semibold text-action-text disabled:opacity-40 hover:brightness-90">
          {{ t('save') }}
        </button>
      </div>
    </ng-template>
  </app-modal>
</ng-container>
